import styled from 'styled-components';

const TagsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
  height: 20px;
`;

export default TagsContainer;
